import type { UiStrings } from "../types";

export const es: UiStrings = {
  nav: {
    category: "Categoría",
    forYourWork: "Para tu Trabajo",
    searchPlaceholder: "Busca entre más de 300 herramientas...",
    heroPlaceholder: "¿Qué tienes en mente?",
  },
  trustBadges: {
    noLogin: "Sin iniciar sesión para usar las herramientas",
    freeUsesDaily: "10 usos de prueba al día",
    filesNeverStored: "Tus archivos nunca se almacenan",
    worksAnyDevice: "Funciona en cualquier dispositivo",
    worksWhenAiBlocked: "Funciona bajo cualquier política de IA de tu empresa",
    availableInLanguages: "Disponible en varios idiomas",
  },
  common: {
    backToHome: "Volver al Inicio",
    home: "Inicio",
    signIn: "Iniciar Sesión",
    account: "Cuenta",
    contact: "Contacto",
    blog: "Blog",
    shareThisTool: "Compartir esta herramienta",
    download: "Descargar",
    copy: "Copiar",
    copied: "Copiado",
  },
  footer: {
    tagline: "Tu plataforma de productividad todo en uno. Más de 300 herramientas profesionales, aplicaciones premium y productos de flujo de trabajo para el día a día.",
    company: "Empresa",
    about: "Acerca de",
    blog: "Blog",
    contact: "Contacto",
    pricing: "Precios",
    privacyPolicy: "Política de Privacidad",
    termsOfService: "Términos de Servicio",
    allTools: "Todas las Herramientas",
    allRightsReserved: "Todos los derechos reservados.",
  },
  contact: {
    title: "Contáctanos",
    subtitle: "¿Preguntas, comentarios o algo que no funciona bien? Estamos aquí para ayudarte.",
    email: "Correo electrónico",
    responseTime: "Tiempo de Respuesta",
    responseTimeValue: "Normalmente respondemos en 1-2 días hábiles.",
    sendEmail: "Envíanos un correo",
    billingNote: "Para preguntas de facturación, incluye el correo electrónico asociado a tu cuenta.",
    whoWeAreTitle: "Quién opera FreeDailyPro",
    whoWeAreBody: "FreeDailyPro es operado por DreamUSA LLC, un pequeño negocio de software gestionado de forma independiente. No hay un gran equipo de soporte detrás de esto: la persona que lee y responde tu correo es también quien construye y mantiene las herramientas, por lo que a veces una respuesta tarda uno o dos días en lugar de ser instantánea.",
    whatWeSupportTitle: "En qué podemos ayudarte",
    whatWeSupportBody: "Informes de errores de cualquiera de las 300+ herramientas, solicitudes de funciones, preguntas de facturación y suscripción (incluyendo cancelaciones y reembolsos), problemas de cuenta e inicio de sesión, y comentarios generales sobre qué funciona bien o no. Si una herramienta produjo un resultado incorrecto, indicar el tipo de archivo y qué salió mal ayuda a solucionarlo más rápido.",
  },
  home: {
    heroTitleLine1: "Cada tarea profesional.",
    heroTitleLine2: "Una plataforma en el navegador",
    heroSubtitle: "Usa una herramienta. Ejecuta un flujo de trabajo. Crea con API y MCP. O deja que lo construyamos por ti.",
    localSignalUsedTitle: "Usadas en este dispositivo",
    localSignalTryTitle: "Prueba una de estas",
    localSignalBadge: "Local \u00b7 Sin red",
    localSignalUsedDesc: "herramientas usadas en este dispositivo \u2014 nada salió de tu navegador",
    localSignalTryDesc: "herramientas usadas hasta ahora en este dispositivo \u2014 todo se ejecuta aquí mismo, en tu navegador",
    corporateSafeTitle: "Seguro para empresas",
    corporateSafeSubtitle: "Sea cual sea la política de IA de tu empresa, FreeDailyPro funciona igual",
    corporateSafeBlockedTitle: "Totalmente bloqueado",
    corporateSafeBlockedDesc: "No se permite ningún tipo de herramienta de IA en la red. Todas las herramientas de FreeDailyPro siguen funcionando \u2014 nada se sube nunca a un servidor.",
    corporateSafeGovernedTitle: "Acceso controlado",
    corporateSafeGovernedDesc: "Solo se permite IA a través de herramientas aprobadas y verificadas. Aquí no se necesita ninguna aprobación \u2014 no hay ninguna llamada a un servidor externo que verificar.",
    corporateSafeOpenTitle: "Sin restricciones",
    corporateSafeOpenDesc: "Usa lo que te haga el trabajo. FreeDailyPro es simplemente más rápido, ya que no hay nada que subir ni esperar.",
    corporateSafeCta: "Ver el desglose completo para empresas \u2192",
    exploreToolkitTitle: "Explora las herramientas",
    exploreToolkitSubtitle: "Más de 300 herramientas en {catCount} categorías \u2014 elige una, o simplemente busca.",
    forYourWorkTitle: "Diseñado para cómo trabajas de verdad",
    forYourWorkSubtitle: "Las mismas herramientas profesionales, organizadas según tu trabajo real",
    exploreTools: "Explorar herramientas",
    seeAllRoles: "Ver los {count} roles \u2192",
    blogTitle: "Del Blog",
    viewAllPosts: "Ver Todas las Publicaciones",
    faqTitle: "¿Tienes una pregunta? Consulta nuestras preguntas frecuentes",
    faqMoreLink: "¿Buscas más respuestas? Explora todas las preguntas frecuentes \u2192",
    toolkitProseTitle: "Un kit de herramientas profesional pensado para el trabajo diario, no solo para tareas puntuales",
    closingCtaTitle: "No olvides añadir el acceso directo",
    closingCtaDesc: "Añádelo una vez y siempre estará a un clic de distancia \u2014 instala el acceso directo de escritorio o añádelo a la pantalla de inicio de tu teléfono, y FreeDailyPro se abrirá como una app nativa, sin buscar pestañas del navegador.",
    categoriesLabel: "{count} CATEGORÍAS \u2192",
    viewAllCategoriesLabel: "VER LAS {count} CATEGORÍAS \u2192",
    yourFavorites: "Tus Favoritos",
    recentlyUsed: "Usados Recientemente",
    toolkitProsePara1: "FreeDailyPro reúne más de 300 herramientas cotidianas \u2014 edición de PDF, conversión de imágenes, recorte de video, limpieza de audio, formato de texto y docenas de calculadoras \u2014 en un solo lugar, para que no tengas que saltar de un sitio a otro para cada tarea. La mayoría de las herramientas no requieren registro, y las herramientas basadas en archivos incluyen 10 usos gratuitos al día.",
    toolkitProsePara2: "Cada herramienta funciona completamente en tu navegador. Cuando comprimes un PDF o eliminas el fondo de una foto, ese archivo nunca sale de tu dispositivo \u2014 no se sube, ni se procesa en un servidor, ni se almacena en ningún lugar, ni siquiera temporalmente. Eso no es una limitación, es todo el diseño: resultados más rápidos, y nada de qué preocuparte si el archivo es sensible.",
    toolkitProsePara3: "Ese enfoque local también significa que FreeDailyPro funciona igual ya sea en una laptop personal, un equipo de trabajo restringido, o una red con políticas estrictas de uso de IA \u2014 no hay ninguna llamada a un servidor externo que el equipo de TI deba evaluar, porque no existe tal llamada.",
    toolkitProsePara4: "Ya sea que necesites combinar PDFs para un informe, redimensionar una imagen para un anuncio, recortar un clip de video para redes sociales, o hacer un cálculo rápido de hipoteca o impuestos, FreeDailyPro está diseñado para ser la herramienta que uses a diario \u2014 no solo la que recuerdas que existe cuando la necesitas.",
    heroLaneToolsTitle: "Herramientas profesionales para tareas individuales",
    heroLaneToolsDesc: "PDF, imagen, video y más -- una acción, hecha en tu navegador.",
    heroLaneToolsCta: "Explorar herramientas",
    heroLanePremiumTitle: "Aplicaciones premium para trabajos mayores",
    heroLanePremiumDesc: "Apps de varios pasos: documentos, formularios, planificadores, impresión y eventos.",
    heroLanePremiumCta: "Ver aplicaciones",
    heroLaneWorkflowTitle: "Productos de flujo de trabajo",
    heroLaneWorkflowDesc: "Book Writing Toolbox, Event Suite y más -- varios pasos, un resultado.",
    heroLaneWorkflowCta: "Ver productos de flujo de trabajo",
    heroLaneApiTitle: "API y MCP",
    heroLaneApiDesc: "Llama a las mismas herramientas desde tu propio código o agente de IA.",
    heroLaneApiCta: "Abrir desarrolladores",
    heroLaneCustomTitle: "Software a medida",
    heroLaneCustomDesc: "Cuéntanos qué necesitas. Lo desarrollamos por un pago único y después pagas una pequeña cuota mensual de uso.",
    heroLaneCustomCta: "Solicitar un desarrollo",
  },
  install: {
    desktopTitle: "Acceso Directo de Escritorio",
    desktopSubtitle: "Un clic, se abre al instante",
    mobileTitle: "App Móvil",
    mobileSubtitle: "Añade a tu pantalla de inicio",
    addToHomeScreenTitle: "Añade FreeDailyPro a tu Pantalla de Inicio",
    iosInstructions: "Toca el ícono de Compartir en Safari y luego elige \"Añadir a pantalla de inicio.\"",
    genericInstructions: "Abre el menú de tu navegador y busca \"Añadir a pantalla de inicio\" o \"Instalar app.\"",
    desktopUnavailableTitle: "La instalación de un clic no está disponible en este navegador",
    desktopUnavailableDesc: "Aun así puedes guardar esta página en tus favoritos, o arrastrar el ícono de la barra de direcciones a tu escritorio.",
    desktopSuccess: "¡Acceso directo creado! Busca el ícono de FreeDailyPro.",
    mobileSuccess: "¡Añadido! Busca el ícono de FreeDailyPro en tu pantalla de inicio.",
  },
  toolPage: {
    proBadge: "Pro",
    usesRemainingToday: "{count} usos de prueba restantes hoy",
    whatThisToolDoes: "Qué hace esta herramienta",
    proTips: "Consejos Pro",
    continueWith: "Continúa con",
    moreFromCategory: "Más de esta categoría",
  },
  usageStrip: {
    freeUsesPerDay: "Prueba: {limit} usos/día",
    remainingToday: "{count} restantes hoy",
    dayPassLabel: "Uso ilimitado sin anuncios, pase de 1 día por $1",
    monthlyLabel: "Uso ilimitado sin anuncios, pase mensual por $4.99",
    quickBuy: "Compra rápida",
  },
  platformsBanner: {
    title: "Dónde vive realmente esta API",
    subtitle: "No es una página que dice \"próximamente\" -- son listados reales y funcionales a los que puedes suscribirte o conectarte hoy mismo.",
    postmanDetail: "Solicitudes listas para usar, totalmente documentadas",
    rapidApiDetail: "Suscríbete con facturación por uso a través del mercado de Rapid",
    mcpRegistryDetail: "Listado oficialmente como com.freedailypro/tools, {mcp} herramientas, un solo endpoint",
  },
  pricingBanner: {
    title: "Precios transparentes",
    subtitle: "Sin niveles ocultos ni límites sorpresa -- exactamente lo que cuesta cada plan y lo que obtienes.",
    toolPricingTitle: "Precios de herramientas por uso",
    apiPricingTitle: "Precios de API y MCP por uso",
    freeLabel: "Prueba",
    freeToolDetail: "10 usos/día en Professional Tools, 2 en Premium Applications",
    dayPassDetail: "$1/día -- uso ilimitado sin anuncios",
    monthlyDetail: "$4.99/mes -- uso ilimitado sin anuncios",
    monthlySavingsNote: "Más barato que 5 pases diarios al mes",
    freeApiDetail: "20,000 llamadas/mes",
    premiumDetail: "$24/mes -- 200,000 llamadas",
    ultraDetail: "$69/mes -- 750,000 llamadas",
    megaDetail: "$129/mes -- 2,000,000 llamadas + prioridad",
  },
  apiMcpBanner: {
    title: "Ahora con API y MCP",
    description: "Llama a nuestras 200+ herramientas directamente desde tu propio código, o conecta un agente de IA por MCP -- las mismas herramientas, del lado del servidor, para cuando el navegador no sea suficiente.",
    oneKey: "Una sola clave para todo",
    restApiMcp: "API REST + MCP",
    anyLanguage: "Cualquier lenguaje, cualquier servidor",
    cta: "Explorar la API y MCP",
  },
  premiumApps: {
    title: "Aplicaciones Premium",
    subtitle: "Aplicaciones reales de varios pasos, no herramientas de una sola acción -- también instalables por separado.",
    seeAll: "Ver todas las aplicaciones Premium",
  },
  googleDrive: {
    openFromGoogle: "Abrir desde Google Drive",
    saveToGoogle: "Guardar en Google Drive",
    signingIn: "Abriendo el inicio de sesión de Google...",
    fetching: "Obteniendo tu archivo de Google Drive...",
    saving: "Guardando en Google Drive...",
    saved: "Guardado en Google Drive",
    viewInDrive: "Ver en Drive",
    popupBlocked: "Tu navegador bloqueó la ventana de inicio de sesión de Google. Permite las ventanas emergentes de este sitio e inténtalo de nuevo.",
    cancelled: "Se cerró el inicio de sesión de Google antes de terminar. No se abrió ni se guardó nada.",
    denied: "No se permitió el acceso a Google Drive, así que no se abrió ni se guardó nada. Inténtalo de nuevo y permite el acceso a los archivos que elijas.",
    loadFailed: "No se pudo conectar con Google. Revisa tu conexión o tu bloqueador de contenido e inténtalo de nuevo.",
    network: "Se perdió la conexión con Google Drive. Inténtalo de nuevo.",
    tooLarge: "Ese archivo es demasiado grande para abrirlo en el navegador.",
    api: "Google Drive no pudo completar la acción. Inténtalo de nuevo.",
    largeFile: "Este archivo supera los 50 MB. Puede tardar más o quedarse sin memoria del navegador.",
    privacyNote: "Tu archivo viaja entre tu navegador y Google. No se envía a nuestros servidores.",
  },
};
